import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const StartSyncCard = ({ isConnected }) => {
  const navigate = useNavigate();

  const handleStartSync = () => {
    if (isConnected) {
      navigate('/playlist-selection-sync-setup');
    } else {
      navigate('/authentication-account-connection');
    }
  };

  return (
    <div className="bg-gradient-to-br from-primary/10 to-secondary/10 border border-primary/20 rounded-lg p-6 lg:p-8 shadow-elevation-2">
      <div className="text-center">
        <div className="flex items-center justify-center w-16 h-16 bg-primary/20 rounded-full mx-auto mb-4">
          <Icon name="Shuffle" size={32} className="text-primary" />
        </div>
        
        <h2 className="text-xl lg:text-2xl font-bold text-text-primary mb-2">
          {isConnected ? 'Ready to Sync!' : 'Get Started'}
        </h2>
        
        <p className="text-text-secondary mb-6 max-w-md mx-auto">
          {isConnected 
            ? 'Your accounts are connected. Start syncing your playlists between Spotify and YouTube Music.'
            : 'Connect your Spotify and YouTube accounts to begin syncing your favorite playlists.'
          }
        </p>

        <div className="space-y-3">
          <Button
            variant="primary"
            size="lg"
            onClick={handleStartSync}
            iconName={isConnected ? "Play" : "Link"}
            iconSize={20}
            className="w-full sm:w-auto"
          >
            {isConnected ? 'Start New Sync' : 'Connect Accounts'}
          </Button>
          
          {isConnected && (
            <div className="flex items-center justify-center space-x-4 text-sm text-text-muted">
              <div className="flex items-center space-x-1">
                <Icon name="Zap" size={16} className="text-warning" />
                <span>Fast sync</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Shield" size={16} className="text-success" />
                <span>Secure</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="RefreshCw" size={16} className="text-primary" />
                <span>Real-time</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StartSyncCard;